


export class featureKeepAlignmentWithSlider {

    public setMargin(element: HTMLElement, margin: number) {
        element.style.paddingLeft = margin + 'px';
    }

}